import { Button } from "@grafit/design-system/components/molecules/button";
import { Trans, useTranslation } from "@grafit/i18n";
import * as React from "react";
import { authClient } from "../auth-client";
import { assertOnline } from "../utils/assert-online";

interface MagicLinkSignInProps {
  email: string;
  disabled: boolean;
  isOnboarding: boolean;
}

export const MagicLinkSignIn = React.memo<MagicLinkSignInProps>(({ email, disabled, isOnboarding }) => {
  const { t } = useTranslation();
  const [isPending, setIsPending] = React.useState(false);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>): Promise<void> {
    e.preventDefault();
    setIsPending(true);

    const trimmedEmail = email.trim();
    if (!trimmedEmail || !assertOnline(t)) {
      setIsPending(false);
      return;
    }

    const callbackURL = isOnboarding ? `${window.location.origin}/onboarding` : window.location.origin;

    try {
      await authClient.signIn.magicLink({
        email: trimmedEmail,
        callbackURL,
        newUserCallbackURL: `${window.location.origin}/onboarding`,
      });
      window.location.replace("/sign-in?success=true");
    } catch {
      window.location.replace("/sign-in?success=true");
    }
  }

  return (
    // oxlint-disable-next-line jsx-no-new-function-as-prop
    <form onSubmit={(e) => void handleSubmit(e)} className="space-y-4" method="post">
      <Button
        variant={{ kind: "primary", renderMode: "fill", size: "m" }}
        type="submit"
        className="w-full"
        isPending={isPending}
        disabled={disabled || isPending || !email.trim()}
        enableCheckmark
      >
        <Trans i18nKey={isPending ? "auth.sign-in.button.sending" : "auth.sign-in.button.send"} />
      </Button>
    </form>
  );
});
MagicLinkSignIn.displayName = "MagicLinkSignIn";
